import { render, staticRenderFns } from "./TradutorModal.vue?vue&type=template&id=3f488bac&"
import script from "./TradutorModal.vue?vue&type=script&lang=js&"
export * from "./TradutorModal.vue?vue&type=script&lang=js&"
import style0 from "./TradutorModal.vue?vue&type=style&index=0&id=3f488bac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports